/**
 * **API User** — PROJECT-OVERVIEW §5.5.
 *
 * Fronts the user-facing Lambdas: Gestão de FinOps · Gestão Orçamentária · Gestão
 * de Compliance · Gestão de Documentos · Busca de Dados · Mensagens · Validador de
 * Status.
 *
 * 🔒 **A screen under `src/modules/admin/` must never import this file.**
 * `eslint.config.js` fails the build if it does, in both the `@/` and the relative
 * form. Use `apiAdm` there.
 */
import { criarCliente } from './criarCliente'

export const apiUser = criarCliente((config) => config.api.user, 'api.user')
